export default __webpack_public_path__ + "static/media/male_blue.92b8ea72.svg";